import { render } from "./App.vue?vue&type=template&id=7b8000b0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7b8000b0&lang=less"

import exportComponent from "/home/workspace/cjg-app-9351/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__